<app-page-title title="Kasa Bakiyeleri" [breadcrumbItems]="breadCrumbItems"></app-page-title>
<app-loader></app-loader>

<ng-container *ngIf="caseList.length > 0">
  <ul ngbNav #nav1="ngbNav" [(activeId)]="activeCase" class="nav-pills">

    <li [ngbNavItem]="case.id" *ngFor="let case of normalCases">
      <!-- POS kasaları da operasyoneldir (banka kasalarının aksine elle hareket girilir),
           bu yüzden ayrı grup değil, aynı şeritte kart simgesiyle işaretlenir. -->
      <a ngbNavLink>
        <i class="mdi mdi-credit-card-outline me-1" *ngIf="case.caseType === CaseType.Pos"></i>{{ case.name }}
      </a>
      <ng-template ngbNavContent>
        <app-case-detail-panel [case]="case"></app-case-detail-panel>
      </ng-template>
    </li>

    <li [ngbNavItem]="group.navId" *ngFor="let group of bankGroups">
      <!-- Sekmede yalnızca logo: ad tooltip'te. Banka sayısı arttıkça uzun
           adlar sekme şeridini taşırıyordu. -->
      <a ngbNavLink class="d-flex align-items-center">
        <app-bank-logo [bankName]="group.bankName" [size]="20"></app-bank-logo>
        <span class="ms-2">{{ group.bankName }}</span>
      </a>
      <ng-template ngbNavContent>
        <ul ngbNav #bankNav="ngbNav" [(activeId)]="group.activeCaseId" class="nav-pills mt-2">
          <li [ngbNavItem]="bankCase.id" *ngFor="let bankCase of group.cases">
            <a ngbNavLink>{{ bankCase.name }}</a>
            <ng-template ngbNavContent>
              <app-case-detail-panel [case]="bankCase"></app-case-detail-panel>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="bankNav" class="mt-2"></div>
      </ng-template>
    </li>

    <li [ngbNavItem]="-1">
      <a class="fs-5 custom-align p-1" ngbNavLink>
        <app-case-create-modal></app-case-create-modal>
      </a>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav1"></div>
</ng-container>
